import React from "react";
import { Card, CardBody, CardHeader } from "../../../_partials/controls";

export default function ComingSoonPage({ cardTitle }) {
  return (
    <>
      <Card>
        <CardHeader title={cardTitle} />
        <CardBody>
          <div class="row pt-8 mt-8 mb-8 pb-8">
            <div className="col"></div>
            <div class="col">
              <h1>Coming Soon!</h1>
            </div>
            <div className="col"></div>
          </div>
        </CardBody>
      </Card>
    </>
  );
}
